import {gsap} from "gsap";
const  businessExampleHover = (y) => {
  $(document).on('mouseenter', '.business-card', function () {
    gsap.to($(this), {y: y ? y : '-20'});
  }).on('mouseleave', '.business-card', function () {
    gsap.to($(this), {y: '0'});
  });
}

export default businessExampleHover;
